/**
 * Flat query-param entries produced by `filterStateToParams` in
 * @parcel/filters. Passed verbatim to list hooks, appended to each request's
 * query string, and folded into react-query keys.
 */
export type FilterParamEntries = ReadonlyArray<readonly [string, string]>;

export function appendFilterEntries(qs: URLSearchParams, entries: FilterParamEntries = []): void {
  for (const [key, value] of entries) qs.append(key, value);
}

/** Canonical string form of the entries for use inside react-query keys. */
export function filterEntriesKey(entries: FilterParamEntries = []): string {
  const canonicalEntries = [...entries].sort(([leftKey, leftValue], [rightKey, rightValue]) => {
    if (leftKey < rightKey) return -1;
    if (leftKey > rightKey) return 1;
    if (leftValue < rightValue) return -1;
    if (leftValue > rightValue) return 1;
    return 0;
  });
  return new URLSearchParams(canonicalEntries.map(([key, value]) => [key, value])).toString();
}
